module.exports = __webpack_public_path__ + "img/managers.1418c70b.svg";